import { Form, Spin } from "antd"
import { useEffect, useState } from "react"
import { ListingActionButtons } from "layoutsV2/pro/ProNewListingLayout/ListingActionButtons"
import { proNewListingMenuList } from "layoutsV2/pro/ProNewListingLayout/proNewListingMenuList"
import { serialize } from "object-to-formdata"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router-dom"
import { modelSelector } from "store/selectors"
import { updateTrip, getGuideTrip } from "store/trips"
import { CustomForm } from "ui/Form"
import { AdditionalDetails } from "./AdditionalDetails"
import { ExperienceDetails } from "./ExperienceDetails"
import { ExperienceInfo } from "./ExperienceInfo"
import { GuestDetails } from "./GuestDetails"
import { PublishingSettings } from "./PublishingSettings"

export const ListingDetails = () => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const { id } = useParams()
  const trip = useSelector(modelSelector("trip"))
  const { licenses_required } = trip
  const location = useLocation()
  const segments = location?.pathname?.split("/")
  const lastSegment = segments?.pop()
  const [selectedLanguages, setSelectedLanguages] = useState([])
  const [selectedSkillLevels, setSelectedSkillLevels] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (id) {
      dispatch(getGuideTrip(id))
    }
  }, [dispatch, id])

  useEffect(() => {
    if (trip) {
      let categories = []
      if (Array.isArray(trip.categories)) {
        categories = trip.categories;
      } else if (trip.categories) {
        categories = [trip.categories];
      }
      form.setFieldsValue({
        title: trip.title,
        description: trip.description,
        categories: categories.length ? categories : undefined,
        min_guests: trip.min_guests,
        max_guests: trip.max_guests,
        languages: trip.languages,
        skill_levels: trip.skill_levels,
        included_items: trip.included_items,
        bring_items: trip.bring_items,
        accessibility_enabled: trip.accessibility_enabled,
        alcohol_allowed: trip.alcohol_allowed,
        children_allowed: trip.children_allowed,
        publish_on_guides_site: trip.publish_on_guides_site,
        publish_on_platform: trip.publish_on_platform
      })
    }
  }, [trip])

  const onFinish = (callback) => {
    if (!id) return

    form.validateFields().then(() => {
      const formData = createFormData()
      handleFormSubmission(formData, callback)
    })
  }

  const createFormData = () => {
    return serialize({ trip: { ...form.getFieldsValue(), price_per_person: 10, skill_levels: selectedSkillLevels, languages: selectedLanguages } }, { allowEmptyArrays: true })
  }

  const handleFormSubmission = (formData, callback) => {
    setIsLoading(true)
    dispatch(updateTrip(id, formData)).then(() => {
      updateDetailsTabStatus()
      setIsLoading(false)
      callback?.()
    }).catch(() => {
      setIsLoading(false)
    })
  }

  const updateDetailsTabStatus = () => {
    const detailsTab = proNewListingMenuList.find((tab) => tab.id === lastSegment)
    if (detailsTab) {
      detailsTab.status = true
    }
  }

  return (
    <Spin spinning={isLoading} size="large" style={{ width: "100%" }}>
      <CustomForm
        form={form}
        initialValues={{
          ...trip,
          licenses_required: licenses_required
        }}
        layout="vertical"
        style={{ maxWidth: "984px" }}
      >
        <ExperienceInfo form={form} />
        <GuestDetails licenses_required={licenses_required} />
        <ExperienceDetails
          form={form}
          setSelectedLanguages={setSelectedLanguages}
          selectedLanguages={selectedLanguages}
          selectedSkillLevels={selectedSkillLevels}
          setSelectedSkillLevels={setSelectedSkillLevels}
        />
        <AdditionalDetails form={form} />
        <PublishingSettings form={form} />
      </CustomForm>
      <ListingActionButtons form={form} onFinish={onFinish} />
    </Spin>
  )
}